module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 18
// module chunks = 1 2 3 4 5 6 7